<h6 class="mb-3">Rules</h6>
<div class="input-group mb-3">
	<input
		[(ngModel)]="newTags"
		(keydown.enter)="addTags()"
		placeholder="Enter tags seperated by a comma"
		class="form-control me-2"
		id="tags"
	/>
</div>
<button *ngFor="let tag of tags" (click)="removeTag(tag)" class="text-capitalize btn btn-duo me-1">
	{{ tag }}
</button>
